import React from "react";
import { graphql } from "gatsby";
import { Helmet } from "react-helmet";

import Layout from "../components/layout";
import Rule from '../components/rule';
import CopyEmailButton from '../components/copy-email-button';

const OrgPage = (props) => {
    const { data: { markdownRemark: { html } } } = props;
    return (
      <Layout>
        <Helmet>
            <title>Artur Sirgu Sõprade Selts</title>
            <meta property="og:title" content="Artur Sirgu Sõprade Selts" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.artursirk.ee/selts/" />
        </Helmet>
        <Rule />
        <h2 style={{textAlign: "center"}}>Artur Sirgu Sõprade Selts</h2>
        <div dangerouslySetInnerHTML={{__html: html}} />
        <Rule />
        <div className="o-grid o-grid--wrap" style={{marginBottom: "18px"}}>
            <div className="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-50@large">
                <h2>Kontakt:</h2>
                <div
                    className="o-grid o-grid--center o-grid--wrap"
                    itemScope={true}
                    itemProp="Person"
                    itemType="http://schema.org/Person"
                >
                    <div className="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-50@small o-grid__cell--width-66@large member-details">
                        <p className="last">
                            <a itemProp="email" href="mailto:info@artursirk.ee">info@artursirk.ee</a>
                            <CopyEmailButton email="info@artursirk.ee" />
                        </p>
                        <p>
                            <a href="https://www.facebook.com/sirkartur/" target="_blank" rel="noopener noreferrer">Facebook</a>
                        </p>
                    </div>
                </div>
            </div>
            <div className="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-50@large">
                <h2>Juhatuse liikmed</h2>
                <div
                    className="o-grid o-grid--center member-details"
                    itemScope={true}
                    itemProp="Person"
                    itemType="http://schema.org/Person"
                >
                    <p itemProp="name">Art Johanson</p>
                    <p itemProp="name">Tarmo Pikner</p>
                    <p itemProp="name">Daniel Mereäär</p>
                    <p itemProp="name">Jaak Madison</p>    
                    <p itemProp="name">Jaak Valge</p>
                </div>
            </div>
        </div>
        <Rule last />
      </Layout>
    );
};

export default OrgPage;

export const query = graphql`
    query {
        markdownRemark(frontmatter: { type: { eq: "org" } }) {
            html
        }
    }
`;
